import styled, { css } from 'styled-components';
import React from 'react';
var base = 14;
var fraction = 1.25;
var small = base / fraction;
var tiny = small / fraction;
var medium = base * fraction;
var large = medium * fraction;
var xlarge = large * fraction;
var xxlarge = xlarge * fraction;
var huge = xxlarge * fraction;
var theme = {
  font: {
    tiny: tiny + "px",
    small: small + "px",
    base: base + "px",
    medium: medium + "px",
    large: large + "px",
    xlarge: xlarge + "px",
    xxlarge: xxlarge + "px",
    huge: huge + "px",
    line: 1.5
  },
  colors: {
    trueBlack: '#000',
    black: '#2C2C2C',
    darkerGray: '#4B4B4B',
    darkGray: '#6E6E6E',
    gray: '#B3B3B3',
    lightGray: '#E1E1E1',
    lighterGray: '#F5F5F5',
    white: '#FAFAFA',
    trueWhite: '#fff',
    primaryDarker: '#095aba',
    primaryDark: '#0d66d0',
    primary: '#1473e6',
    primaryLight: '#2680eb',
    successDarker: '#107154',
    successDark: '#12805c',
    success: '#268e6c',
    successLight: '#2d9d78',
    dangerDarker: '#bb121a',
    dangerDark: '#c9252d',
    danger: '#d7373f',
    dangerLight: '#e34850'
  }
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  color: ", ";\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,\n    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  font-size: ", ";\n  line-height: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var reset = css(_templateObject(), theme.colors.black, theme.font.base, theme.font.line);

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  background: none;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var buttonReset = css(_templateObject$1(), reset);

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin: 0;\n  padding: 0;\n  font-size: ", ";\n  padding-bottom: 0.5em;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var H = styled.div(_templateObject$2(), reset, function (props) {
  return props.theme.font[props.size];
});

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin: 0;\n  padding: 0;\n  padding-bottom: 1em;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var P = styled.p(_templateObject$3(), reset);

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  padding: 0.5em 1em;\n  margin-right: 0.25em;\n  border: 2px solid ", ";\n  border-radius: 48px;\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  line-height: 1;\n  transition: 0.1s ease-in-out all;\n\n  &:focus {\n    border-color: ", ";\n  }\n\n  &:hover {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:last-of-type {\n    margin-right: 0;\n  }\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var variants = {
  primary: {
    border: 'primary',
    background: 'primary',
    color: 'white',
    hoverBorder: 'primaryDark',
    hoverBackground: 'primaryDark',
    hoverColor: 'white',
    activeBorder: 'primaryDarker',
    activeBackground: 'primaryDarker',
    activeColor: 'white'
  },
  secondary: {
    border: 'darkerGray',
    background: 'white',
    color: 'darkerGray',
    hoverBorder: 'darkGray',
    hoverBackground: 'darkGray',
    hoverColor: 'white',
    activeBorder: 'darkerGray',
    activeBackground: 'darkerGray',
    activeColor: 'white'
  },
  success: {
    border: 'success',
    background: 'success',
    color: 'white',
    hoverBorder: 'successDark',
    hoverBackground: 'successDark',
    hoverColor: 'white',
    activeBorder: 'successDarker',
    activeBackground: 'successDarker',
    activeColor: 'white'
  },
  danger: {
    border: 'danger',
    background: 'danger',
    color: 'white',
    hoverBorder: 'dangerDark',
    hoverBackground: 'dangerDark',
    hoverColor: 'white',
    activeBorder: 'dangerDarker',
    activeBackground: 'dangerDarker',
    activeColor: 'white'
  }
};
var sizes = {
  sm: theme.font.small,
  md: theme.font.base,
  lg: theme.font.medium
};

var getColor = function getColor(props, variant, key) {
  return props.theme.colors[variants[variant][key]];
};

var Button = styled.button(_templateObject$4(), buttonReset, function (props) {
  return getColor(props, props.variant, 'border');
}, function (props) {
  return getColor(props, props.variant, 'background');
}, function (props) {
  return getColor(props, props.variant, 'color');
}, function (props) {
  return sizes[props.size || 'md'];
}, function (props) {
  return getColor(props, props.variant, 'activeBorder');
}, function (props) {
  return getColor(props, props.variant, 'hoverBorder');
}, function (props) {
  return getColor(props, props.variant, 'hoverBackground');
}, function (props) {
  return getColor(props, props.variant, 'hoverColor');
}, function (props) {
  return getColor(props, props.variant, 'activeBorder');
}, function (props) {
  return getColor(props, props.variant, 'activeBackground');
}, function (props) {
  return getColor(props, props.variant, 'activeColor');
});
Button.defaultProps = {
  type: 'button',
  variant: 'primary'
};

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  position: relative;\n  top: 3px;\n  margin-right: 2em;\n  padding: 0 0 0.5em 0;\n  border-bottom: 3px solid\n    ", ";\n  color: ", ";\n  font-weight: 500;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &:last-of-type {\n    margin-right: 4em;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: inline-flex;\n  margin-bottom: 1em;\n  border-bottom: 3px solid ", ";\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var TabsWrapper = styled.div(_templateObject$5(), reset, function (props) {
  return props.theme.colors.lightGray;
});
var Tab = styled.button(_templateObject2(), buttonReset, function (props) {
  return props.active ? props.theme.colors.black : 'transparent';
}, function (props) {
  return props.active ? props.theme.colors.black : props.theme.colors.darkGray;
}, function (props) {
  return props.theme.colors.black;
});

var Tabs = function Tabs(_ref) {
  var _ref$initial = _ref.initial,
      initial = _ref$initial === void 0 ? 0 : _ref$initial,
      children = _ref.children;

  var _React$useState = React.useState(initial),
      current = _React$useState[0],
      setCurrent = _React$useState[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabsWrapper, null, children.map(function (child, idx) {
    return /*#__PURE__*/React.createElement(Tab, {
      key: idx,
      type: "button",
      active: idx === current,
      onClick: function onClick() {
        return setCurrent(idx);
      }
    }, child.props.title);
  })), children[current]);
};

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  border: 0;\n  outline: 0;\n  border-radius: 4px;\n  border: 0;\n  width: 100%;\n  padding: 0.5em 0.75em;\n  border: 1px solid ", ";\n  background-color: ", ";\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var Input = styled.input(_templateObject$6(), reset, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.trueWhite;
}, function (props) {
  return props.theme.colors.darkGray;
}, function (props) {
  return props.theme.colors.primary;
});

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  border: 0;\n  outline: 0;\n  border-radius: 4px;\n  border: 0;\n  width: 100%;\n  height: 100px;\n  padding: 0.5em 0.75em;\n  border: 1px solid ", ";\n  background-color: ", ";\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var Textarea = styled.textarea(_templateObject$7(), reset, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.trueWhite;
}, function (props) {
  return props.theme.colors.darkGray;
}, function (props) {
  return props.theme.colors.primary;
});

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  border: 0;\n  outline: 0;\n  border-radius: 4px;\n  border: 0;\n  width: 100%;\n  padding: 0.5em 0.75em;\n  border: 1px solid ", ";\n  background-size: 16px;\n  background-repeat: no-repeat;\n  background-position: center right 0.25em;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLWNoZXZyb24tZG93biI+PHBvbHlsaW5lIHBvaW50cz0iNiA5IDEyIDE1IDE4IDkiPjwvcG9seWxpbmU+PC9zdmc+);\n  background-color: ", ";\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var Select = styled.select(_templateObject$8(), reset, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.trueWhite;
}, function (props) {
  return props.theme.colors.darkGray;
}, function (props) {
  return props.theme.colors.primary;
});

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  width: 100%;\n  margin-bottom: 1em;\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var FormGroup = styled.div(_templateObject$9(), reset);

function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: block;\n  margin-bottom: 0.25em;\n  color: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  cursor: pointer;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var Label = styled.label(_templateObject$a(), reset, function (props) {
  return props.theme.colors.darkerGray;
}, function (props) {
  return props.theme.font.small;
});

var Field = function Field(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'input' : _ref$as,
      r = _ref.r,
      name = _ref.name,
      label = _ref.label,
      wrapperProps = _ref.wrapperProps,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "r", "name", "label", "wrapperProps"]);

  var types = {
    input: Input,
    select: Select,
    textarea: Textarea
  };
  var Component = types[as];
  return /*#__PURE__*/React.createElement(FormGroup, wrapperProps, label && /*#__PURE__*/React.createElement(Label, {
    htmlFor: name
  }, label), /*#__PURE__*/React.createElement(Component, _extends({
    ref: r,
    id: name,
    name: name
  }, props)));
};

function _templateObject$b() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: ", ";\n  opacity: 0.7;\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var Hint = styled.div(_templateObject$b(), function (props) {
  return props.theme.font.small;
});

function _templateObject$c() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin-bottom: 1em;\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var Toolbar = styled.div(_templateObject$c(), reset);

function _templateObject$d() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: ", ";\n  align-items: ", ";\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

var Stack = styled.div(_templateObject$d(), function (props) {
  return props.h;
}, function (props) {
  return props.v;
});

function _templateObject$e() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  padding-top: ", ";\n  padding-bottom: ", ";\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}

var Container = styled.div(_templateObject$e(), reset, function (props) {
  return props.top && '1em';
}, function (props) {
  return props.bottom && '1em';
});

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: 1em;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.25em 0.25em 0.25em;\n  border-bottom: 1px solid #ddd;\n  background-color: ", ";\n  font-weight: 700;\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$f() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  margin-bottom: 0.5em;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  background-color: #fff;\n\n  &.sortable-selected {\n    background-color: #0a0a;\n  }\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}

var Panel = styled.div(_templateObject$f(), reset);
var PanelTitle = styled.div(_templateObject2$1(), reset, function (props) {
  return props.theme.colors.lighterGray;
});
var PanelContent = styled.div(_templateObject3());

function _templateObject$g() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 2em;\n  height: 2em;\n  background-size: 50%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLW1vcmUtdmVydGljYWwiPjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEiPjwvY2lyY2xlPjxjaXJjbGUgY3g9IjEyIiBjeT0iNSIgcj0iMSI+PC9jaXJjbGU+PGNpcmNsZSBjeD0iMTIiIGN5PSIxOSIgcj0iMSI+PC9jaXJjbGU+PC9zdmc+);\n  cursor: grabbing;\n  filter: invert(", ");\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}

var Handle = styled.div(_templateObject$g(), function (props) {
  return props.active ? 1 : 0;
});

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  padding: 1em 2em 2em 2em;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  position: relative;\n  right: -12px;\n  z-index: 13;\n  width: 2em;\n  height: 2em;\n  margin: 0;\n  padding: 0;\n  background-repeat: no-repeat;\n  background-size: 80%;\n  background-position: center;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLXgiPjxsaW5lIHgxPSIxOCIgeTE9IjYiIHgyPSI2IiB5Mj0iMTgiPjwvbGluZT48bGluZSB4MT0iNiIgeTE9IjYiIHgyPSIxOCIgeTI9IjE4Ij48L2xpbmU+PC9zdmc+);\n  font-size: 1em;\n  overflow: hidden;\n  text-indent: -9999px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  font-size: 1.25em;\n  font-weight: 500;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.25em 2em;\n  border-bottom: 2px solid ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  width: 80%;\n  border-radius: 5px;\n  background-color: ", ";\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n  pointer-events: all;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 12;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none;\n"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$h() {
  var data = _taggedTemplateLiteralLoose(["\n  ", ";\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 11;\n  background-color: rgba(0, 0, 0, 0.6);\n  cursor: pointer;\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}

var Overlay = styled.div(_templateObject$h(), reset);
var Wrapper = styled.div(_templateObject2$2(), reset);
var Inner = styled.div(_templateObject3$1(), reset, function (props) {
  return props.theme.colors.lighterGray;
});
var TitleBar = styled.div(_templateObject4(), reset, function (props) {
  return props.theme.colors.lightGray;
});
var Title = styled.div(_templateObject5(), reset);
var CloseButton = styled.button(_templateObject6(), buttonReset);
var Content = styled.div(_templateObject7(), reset);

var Modal = function Modal(_ref) {
  var title = _ref.title,
      children = _ref.children,
      onClose = _ref.onClose;

  var handleKeyUp = function handleKeyUp(_ref2) {
    var key = _ref2.key;
    if (key === 'Escape') onClose();
  };

  React.useEffect(function () {
    document.addEventListener('keyup', handleKeyUp);
    return function () {
      document.removeEventListener('keyup', handleKeyUp);
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Overlay, {
    onClick: onClose
  }), /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Inner, null, /*#__PURE__*/React.createElement(TitleBar, null, /*#__PURE__*/React.createElement(Title, null, title), /*#__PURE__*/React.createElement(CloseButton, {
    type: "button",
    onClick: onClose
  }, "\xD7")), /*#__PURE__*/React.createElement(Content, null, children))));
};

export { Button, Container, Field, FormGroup, H, Handle, Hint, Input, Label, Modal, P, Panel, PanelContent, PanelTitle, Select, Stack, Tabs, Textarea, Toolbar, buttonReset, reset, theme };